import styled from '@emotion/styled'
import { spacing } from 'main/ui'

export const Container = styled.div`
  cursor: pointer;
  margin-top: ${spacing.majorScale(1)}px;
  position: relative;
`
export const MessageCircleContainer = styled.div`
  transform: rotateY(180deg);
`
export const MessageSquareContainer = styled.div`
  position: absolute;
  bottom: 3px;
  right: 9px;
`
export const CircleCountContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 4px;
`
